"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventUrl = exports.default = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _querystring = _interopRequireDefault(require("querystring"));
var _menu = require("@kyruus/menu");
var _Yahoo = _interopRequireDefault(require("@kyruus/react-ikons/Yahoo"));
var _Apple = _interopRequireDefault(require("@kyruus/react-ikons/Apple"));
var _Google = _interopRequireDefault(require("@kyruus/react-ikons/Google"));
var _Windows = _interopRequireDefault(require("@kyruus/react-ikons/Windows"));
var _utils = require("./utils");
var _styles = require("./styles");
const GOOGLE_BASE_URL = 'https://www.google.com/calendar/event?';
const YAHOO_BASE_URL = 'https://calendar.yahoo.com/?';
const ICS_MODES = ['apple', 'outlook'];

// Get a url for linking to a specific type of event
const getEventUrl = (event, mode) => {
  let eventUrl;
  switch (mode) {
    case 'google':
      eventUrl = GOOGLE_BASE_URL + _querystring.default.stringify({
        action: 'TEMPLATE',
        text: event.title,
        dates: `${(0, _utils.formatDateTime)(event.start)}/${(0, _utils.formatDateTime)(event.end)}`,
        details: event.details,
        location: event.location
      });
      break;
    case 'yahoo':
      eventUrl = YAHOO_BASE_URL + _querystring.default.stringify({
        v: 60,
        title: event.title,
        desc: event.details,
        st: (0, _utils.formatDateTime)(event.start),
        dur: (0, _utils.deriveDuration)(event.start, event.end),
        in_loc: event.location
      });
      break;
    default:
      eventUrl = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', `DTSTART:${(0, _utils.formatDateTime)(event.start)}`, `DTEND:${(0, _utils.formatDateTime)(event.end)}`, `SUMMARY:${event.title}`, `DESCRIPTION:${event.details}`, `LOCATION:${event.location}`, 'END:VEVENT', 'END:VCALENDAR'].join('\n');

      // Desktop browsers have poor support for data URIs while the mobile devices we tested were able to open them
      eventUrl = (0, _utils.isMobile)() ? encodeURI(`data:text/calendar;charset=utf8,${eventUrl}`) : (0, _utils.getBlobUrl)(eventUrl);
      break;
  }
  return eventUrl;
};

/**
 * Get the button contents based on the mode.
 *
 * @param {string} mode - a string representing the mode (google, apple, etc...) of the calendar
 * @param modeLabels - has the following shape:  
*   {
      apple: PropTypes.string,
      google: PropTypes.string,
      outlook: PropTypes.string,
      yahoo: PropTypes.string
    })
    These represent the text strings for the various calendar modes. This is set within the larger AddToCalendar component and passed into
    the CalendarEvent components.
 */
exports.getEventUrl = getEventUrl;
const getButtonContent = (mode, modeLabels) => {
  switch (mode) {
    case 'apple':
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Apple.default, {
        size: "1em"
      }), /*#__PURE__*/_react.default.createElement(_styles.LeftMarginSpan, null, modeLabels.apple || 'Apple Calendar'));
    case 'google':
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Google.default, {
        size: "1em"
      }), /*#__PURE__*/_react.default.createElement(_styles.LeftMarginSpan, null, modeLabels.google || 'Google (online)'));
    case 'outlook':
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Windows.default, {
        size: "1em"
      }), /*#__PURE__*/_react.default.createElement(_styles.LeftMarginSpan, null, modeLabels.outlook || 'Outlook'));
    case 'yahoo':
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Yahoo.default, {
        size: "1em"
      }), /*#__PURE__*/_react.default.createElement(_styles.LeftMarginSpan, null, modeLabels.yahoo || 'Yahoo (online)'));
    default:
      return '';
  }
};

/**
 * Represents a link to a calendar event compatible with 4 different calendars
 * Apple calendar, Google calendar, Outlook desktop calendar, & Yahoo calendar
 */
const CalendarEvent = _ref => {
  let {
    onClick,
    mode,
    event,
    modeLabels
  } = _ref;
  let url = getEventUrl(event, mode);

  // There's a bug on iOS where the calendar event (on ICS files) immediately closes if opened in a new tab
  const target = (0, _includes.default)(ICS_MODES).call(ICS_MODES, mode) ? undefined : '_blank';
  return /*#__PURE__*/_react.default.createElement(_menu.MenuItem, {
    id: mode + '-add-to-calendar',
    download: "appointment.ics",
    onClick: onClick,
    component: "a",
    rel: "noopener noreferrer",
    target: target,
    href: url
  }, getButtonContent(mode, modeLabels));
};
CalendarEvent.propTypes = {
  /**
   * A function that will get called when the component is clicked (in addition to opening the link)
   */
  onClick: _propTypes.default.func,
  /**
   * The mode of this calendar event ('apple', 'google', 'outlook', 'yahoo')
   */
  mode: _propTypes.default.oneOf(['apple', 'google', 'outlook', 'yahoo']).isRequired,
  /**
   * The event data that this calendar event will create
   */
  event: _propTypes.default.shape({
    /**
     * The title or name of the event
     */
    title: _propTypes.default.string.isRequired,
    /**
     * Some additional information describing the event
     */
    details: _propTypes.default.string.isRequired,
    /**
     * The location where the event will take place
     */
    location: _propTypes.default.string.isRequired,
    /**
     * ISO8601 UTC string indicating when the event will start
     */
    start: _propTypes.default.string.isRequired,
    /**
     * ISO8601 UTC string indicating when the event will end
     */
    end: _propTypes.default.string.isRequired
  }).isRequired,
  modeLabels: _propTypes.default.shape({
    apple: _propTypes.default.string,
    google: _propTypes.default.string,
    outlook: _propTypes.default.string,
    yahoo: _propTypes.default.string
  })
};
var _default = exports.default = CalendarEvent;
CalendarEvent.__docgenInfo = {
  "description": "Represents a link to a calendar event compatible with 4 different calendars\nApple calendar, Google calendar, Outlook desktop calendar, & Yahoo calendar",
  "methods": [],
  "displayName": "CalendarEvent",
  "props": {
    "onClick": {
      "description": "A function that will get called when the component is clicked (in addition to opening the link)",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "mode": {
      "description": "The mode of this calendar event ('apple', 'google', 'outlook', 'yahoo')",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'apple'",
          "computed": false
        }, {
          "value": "'google'",
          "computed": false
        }, {
          "value": "'outlook'",
          "computed": false
        }, {
          "value": "'yahoo'",
          "computed": false
        }]
      },
      "required": true
    },
    "event": {
      "description": "The event data that this calendar event will create",
      "type": {
        "name": "shape",
        "value": {
          "title": {
            "name": "string",
            "description": "The title or name of the event",
            "required": true
          },
          "details": {
            "name": "string",
            "description": "Some additional information describing the event",
            "required": true
          },
          "location": {
            "name": "string",
            "description": "The location where the event will take place",
            "required": true
          },
          "start": {
            "name": "string",
            "description": "ISO8601 UTC string indicating when the event will start",
            "required": true
          },
          "end": {
            "name": "string",
            "description": "ISO8601 UTC string indicating when the event will end",
            "required": true
          }
        }
      },
      "required": true
    },
    "modeLabels": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "apple": {
            "name": "string",
            "required": false
          },
          "google": {
            "name": "string",
            "required": false
          },
          "outlook": {
            "name": "string",
            "required": false
          },
          "yahoo": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    }
  }
};